import { render, staticRenderFns } from "./institutionList.vue?vue&type=template&id=1ffd1ac8&scoped=true&"
import script from "./institutionList.vue?vue&type=script&lang=js&"
export * from "./institutionList.vue?vue&type=script&lang=js&"
import style0 from "./institutionList.vue?vue&type=style&index=0&id=1ffd1ac8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ffd1ac8",
  null
  
)

export default component.exports